module.exports = __webpack_public_path__ + "static/media/ausvg7.0b418a67.svg";